export const getVisible = (visibleFields, field) => {
  if (visibleFields.includes(field)) return true;
  return false;
};

export const getRequired = (requiredFields, field) => {
  if (requiredFields.includes(field)) return true;
  return false;
};
